import React, {useState, useEffect} from 'react';
import { rbac } from '../index';
import t from '../../../helpers/t';
import Loader from '../../../components/Loader';
import SidebarFilter from '../../../components/SidebarFilter';
import SidebarMenu from "../../reservations/components/SidebarMenu";
import { useSelector, locationActions, userActions, paymentsActions} from "inbooma-api";
import {Biscuit, getAllUrlParams} from "../../../../utils";
import {$,moment} from '../../../../../vendor';
import {getApiHost} from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";
const TransactionsSidebar = (props) => {

    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href)
    allUrlParams?.location_name !== undefined && delete allUrlParams.client_name;
    allUrlParams?.payment_type_name !== undefined && delete allUrlParams.payment_type_name;
    allUrlParams?.payment_status_name !== undefined && delete allUrlParams.payment_status_name;
    allUrlParams?.month_name !== undefined && delete allUrlParams.month_name;
    let language = Biscuit.get('user.lang').replace('-','_');
    const cleanState = {locationFilter:false,paymentMethodFilter:false,paymentStatusFilter:false,fromFilter:false,toFilter:false,quickTimeFilter:false,monthFilter:false};
    const [usedFilterCount,setUsedFilterCount] = useState(
        {locationFilter:allUrlParams?.location_id !== undefined ? true : false,
            paymentMethodFilter:allUrlParams?.payment_type !== undefined ? true : false,
            paymentStatusFilter:allUrlParams?.paystate !== undefined ? true : false,
            fromFilter:allUrlParams?.begin_gte !== undefined ? true : false,
            toFilter:allUrlParams?.end_lte !== undefined ? true : false,
            quickTimeFilter:allUrlParams?.begin_gte !== undefined && allUrlParams?.begin_lte !== undefined ? true : false,
            monthFilter:allUrlParams?.begin_gte !== undefined && allUrlParams?.begin_lte !== undefined ? true : false
        });
    const [ready,setReady] = useState(false);
    const [globalFilter,setGlobalFilter] = useState();                  // default values?
    const [filterCount, setFilterCount] = useState(Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0);
    const [locationFilter, setLocationFilter] = useState(searchParams.get("location_id") !== null ? searchParams.get("location_id") : 'all');
    const [paymentMethodFilter, setPaymentMethodFilter] = useState(searchParams.get("payment_type") !== null ? searchParams.get("payment_type"): '');
    const [paystateFilter, setPaystateFilter] = useState(searchParams.get("paystate") !== null ? searchParams.get("paystate") : '');
    const [locations,setLocations] = useState([]);
    const [users,setUsers] = useState([]);

    const [locationsPending,setLocationsPending] = useState(false);
    const _locations = useSelector(state => state.locations_data.locations);

    const [usersPending,setUsersPending] = useState(false);
    const _users = useSelector(state => state.users_data.users);

    const [selectedDateFrom,setSelectedDateFrom] = useState(searchParams.get("begin_gte") !== null ? moment(searchParams.get("begin_gte"), 'YYYY-MM-DD').toDate() : null);
    const [selectedDateTo,setSelectedDateTo] = useState(searchParams.get("end_lte") !== null ? moment(searchParams.get("end_lte"), 'YYYY-MM-DD').toDate() : null);

    const [monthList,setMonthList] = useState([]);
    const [_resetFilter,_setResetFilter] = useState(props.resetFilter);
    const [selectedQuickfilter,setSelectedQuickfilter] = useState(searchParams.get("quickTime") !== null ? searchParams.get("quickTime") : null);    // default: nothing selected
    const [selectedMonthfilter,setSelectedMonthfilter] = useState(searchParams.get("month") !== null ? searchParams.get("month") : "");

    const onFilterCountChangeHandle = (value) => {
        let clone = {...value};
        let count = 0;
        for (const [type, val] of Object.entries(clone)) {
            if(val){
                count++;
            }
        }
        if(count < 1){
            count = 0;
            $('#inb-selected-filters').addClass('hidden');
        } else {
            $('#inb-selected-filters').removeClass('hidden');
        }
        setFilterCount(count);

    };
    const resetFilter = () =>
    {
        let clone = {};
        setLocationFilter('all');
        setPaymentMethodFilter('');
        setPaystateFilter('');
        setSelectedDateFrom(null);
        setSelectedDateTo(null),
            setSelectedQuickfilter(null);
        setSelectedMonthfilter('');
        setFilterCount(0);
        setUsedFilterCount(cleanState);
        onFilterCountChangeHandle(cleanState);

        const newRelativePathQuery = window.location.pathname;
        history.pushState(null, "", newRelativePathQuery);
        props.filterChangedHandle(clone);
    }

    const getLocationName = (locationId) => {
        let name = "";
        locations.map(location => {
            if(location.id === locationId){
                name = location.name;
                return;
            }
        });
        return name;
    }
    /**
     * can be generally defined in common sidebar
     * @param {event} ev 
     */
    const onToggleLeftBar = (ev) => {

        $('#inb-c-sidebar').toggleClass('open');
        $('html,body').scrollTop(0);
    };

    // method can be used to proof if filter combination is valid
    const onLocationSelectHandle = (location) => {

        // should validate filter combination and start request
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (location !== '' && location !== null) {
            // add status filter to global filter
            clone.location_id = location;
            clone2.locationFilter = true;
            searchParams.set('location_id', location);
            searchParams.set('location_name', getLocationName(location));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['location_id'];
            clone2.locationFilter = false;
            searchParams.delete('location_id');
            searchParams.delete('location_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setLocationFilter(location);
        setUsedFilterCount(clone2);

        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);

    };

    const onLocationQueryHandle = (query) => {

        console.log("Q: ",query);
        // start dispatch of location query
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const onQuickFilterSelectHandle = (value) => {
        console.log("quick filter: ",value);
        let none = false;
        // remove all date filter
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        switch (value) {
            case 'previous_year':
                const prevYear = Number(moment().format('YYYY'))-1;
                clone.end_lte = prevYear + "-12-31";
                clone.begin_gte = prevYear + "-01-01";
                break;
            case 'current_day':
                const day = moment().format('DD');
                clone.end_lte = moment().format('YYYY-MM-DD');
                clone.begin_gte = moment().format('YYYY-MM') + '-' + day;
                break;
            case 'previous_day':
                const prevDay = Number(moment().format('DD'))-1;
                clone.end_lte = moment().format('YYYY-MM') + '-' + prevDay;
                clone.begin_gte = moment().format('YYYY-MM') + '-' + prevDay;
                break;
            case '':
            default:
                delete clone.end_lte;
                delete clone.begin_gte;
                none = true;
        }
        clone2.quickTimeFilter = !none;
        if(!none) {
            searchParams.set('quickTime', value);
        } else {
            searchParams.delete('quickTime');
        }
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('end_lte');
        searchParams.delete('begin_gte');
        clone2.monthFilter=false;
        clone2.fromFilter = false;
        clone2.toFilter=false;
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setSelectedQuickfilter(value);
        setGlobalFilter(clone);
        // reset datepickers
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset month filter
        setSelectedMonthfilter("");
        setSelectedQuickfilter(value);


        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const selectedDateToHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.end_lte = moment(date).format('YYYY-MM-DD');

            clone2.toFilter=true;
            setSelectedDateTo(date);
            searchParams.set('end_lte', clone.end_lte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            delete clone['end_lte'];
            clone2.toFilter=false;
            setSelectedDateTo('');
            searchParams.delete('end_lte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        // reset month and quick filter
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setSelectedMonthfilter("");
        setSelectedQuickfilter(null);
        clone2.monthFilter = false;
        clone2.quickTimeFilter = false;
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const selectedDateFromHandle = (date) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if(date) {
            clone.begin_gte = moment(date).format('YYYY-MM-DD');

            clone2.fromFilter=true;
            setSelectedDateFrom(date);
            searchParams.set('begin_gte', clone.begin_gte);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            delete clone['begin_gte'];
            clone2.fromFilter=false;
            setSelectedDateFrom('');
            searchParams.delete('begin_gte');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        searchParams.delete('month_name');
        searchParams.delete('month');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        setGlobalFilter(clone);
        // reset month and quick filter
        clone2.monthFilter = false;
        clone2.quickTimeFilter = false;
        setUsedFilterCount(clone2);
        setSelectedMonthfilter("");
        setSelectedQuickfilter(null);
        onFilterCountChangeHandle(clone2);
        props.filterChangedHandle(clone);
    };

    const dateKeyDownHandle = (e) => {
        console.log("key down date: ",e);
    };
    
    const onUserSelectHandle = (user) => {

        // should vaildate filter combo
        var clone = {...globalFilter};
        clone.user_id = user;
        setGlobalFilter(clone);

        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };

    const onPaymentTypeSelectHandle = (paymentType) => {

        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (paymentType !== '') {
            // add status filter to global filter
            clone.payment_type = paymentType;
            clone2.paymentMethodFilter = true;
            searchParams.set('payment_type', paymentType);
            searchParams.set('payment_type_name', t(paymentType,null,'capital'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['payment_type'];
            clone2.paymentMethodFilter = false;
            searchParams.delete('payment_type');
            searchParams.delete('payment_type_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setPaymentMethodFilter(paymentType);
        setUsedFilterCount(clone2);

        setGlobalFilter(clone);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };

    const onPaystateSelectHandle = (payState) => {
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};
        if (payState !== '') {
            // add status filter to global filter
            clone.paystate = payState;
            clone2.paymentStatusFilter = true;
            searchParams.set('paystate', payState);
            searchParams.set('payment_status_name', t(payState,null,'capital'));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else {
            // remove status filter from global filter
            delete clone['paystate'];
            clone2.paymentStatusFilter = false;
            searchParams.delete('paystate');
            searchParams.delete('payment_status_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        setGlobalFilter(clone);
        setPaystateFilter(payState);
        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    }

    const onMonthSelectHandle = (month) => {

        // should vaildate filter combo
        // reset all other time or date filter!
        let clone = {...globalFilter};
        let clone2 = {...usedFilterCount};

        if (month === "") {
            // reset time / date filter
            delete clone.end_lte;
            delete clone.begin_gte;
            clone2.monthFilter = false;
            searchParams.delete('month');
            searchParams.delete('month_name');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            setSelectedMonthfilter('');

        } else {
            setSelectedMonthfilter(month);
            //let _month = '' + month;
            //if (_month.length == 1) _month = '0' + _month;

            // compute created_lt and created_gte
            //const prefix = moment().format('YYYY') + '-' + _month + '-01';

            const startOfMonth = moment(month).startOf('month').format('YYYY-MM-DD');
            const endOfMonth   = moment(month).endOf('month').format('YYYY-MM-DD');

            clone.end_lte = endOfMonth;
            clone.begin_gte = startOfMonth;
            clone2.monthFilter = true;

            searchParams.set('month',month);
            searchParams.set('month_name',getNameOfMonth(Number(moment(month).format('MM'))-1));
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            //clone.limit = 100000;
        }

        setGlobalFilter(clone);
        clone2.fromFilter = false;
        clone2.toFilter = false;
        clone2.quickTimeFilter = false;
        // reset datepicker
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset quick filter
        setSelectedQuickfilter(null);

        setUsedFilterCount(clone2);
        onFilterCountChangeHandle(clone2);
        searchParams.delete('end_lte');
        searchParams.delete('begin_gte');
        searchParams.delete('quickTime');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        // fetch wallet transactions
        props.filterChangedHandle(clone);
    };

    const onUserQueryHandle = (query) => {

        console.log("Q: ",query);
        // start dispatch of user query
        props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1,
                q: query
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };

    const getUserDisplayName = (user) => {

        return user.first_name + ' ' + user.last_name;
    };

    const getNameOfMonth = (m) => {

        switch (m) {
            case 0:
                return t('january');
            case 1:
                return t('february');
            case 2:
                return t('march');
            case 3:
                return t('april');
            case 4:
                return t('may');
            case 5:
                return t('june');
            case 6:
                return t('july');
            case 7:
                return t('august');
            case 8:
                return t('september');
            case 9:
                return t('october');
            case 10:
                return t('november');
            case 11:
                return t('december');
            default:
                return "";
        }
    };

    const initMonthList = () => {

        var month = [{name:'- ' + t('select month') + ' -',value:""}];
        var count = 12;
        const currentMonth = moment().month();
        const currentYear = moment().year();

        for (var i=currentMonth;i>=0;i--) {
            month.push({
                name: getNameOfMonth(i) + " " + currentYear,
                value: currentYear + "-" + (i<9 ? "0" + (i+1) : (i+1) ),
            });
            count--;
        }

        var j=0;
        while (count>0) {
            console.log("name: ",getNameOfMonth(11-j));
            month.push({
                name: getNameOfMonth(11-j) + " " + (currentYear-1),
                value: currentYear-1 + "-" + (j>2 ? "0" + (12-j) : (12-j) )     // value matching format of moment
            });
            count--;
            j++;
        }
        setMonthList(month);
    };

    useEffect(() => {

        if (_locations.success == "") return;
    
        if (_locations.success === true) {
            setLocations([..._locations.data]);
        } else if (_locations.success === false) {
            console.log("Failed to request users!");
        }
        setLocationsPending(false);
        if (usersPending === false) setReady(true);
    },[_locations]);

    useEffect(() => {

        if (_users.success == "") return;
    
        if (_users.success === true) {
            // compute name attribute '_name'
            var clone = [..._users.data];
            for (var i=0;i<clone.length;i++) {
                clone[i]._name = getUserDisplayName(clone[i]);
            }
            console.log("clone: ",clone);
            setUsers(clone);
        } else if (_users.success === false) {
            console.log("Failed to request users!");
        }
        setUsersPending(false);
        if (locationsPending === false) setReady(true);
    },[_users]);

    useEffect(() => {

        if (!_resetFilter) return;

        if (_resetFilter) {
            resetFilter();
        }
        _setResetFilter(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_resetFilter]);
    const initialize = () => {

        if (ready) return;

        if (locationsPending || usersPending) return;

        // get locations and users to filter for
        props.dispatch(locationActions.getLocations({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1
            },
        }));
        setLocationsPending(true);

        props.dispatch(userActions.getUsers({
            token: Biscuit.get('token'),
            filter: {
                findForSelect: true,
                find: 'short',
                limit: 999,
                page: 1
            }
        }));
        setUsersPending(true);

        initMonthList();
    };

    if (!ready) initialize();
    const _export = () => {
        let params = '', count=0, begin = null, end =null;
        var clone = {...globalFilter};
        for (const [type, val] of Object.entries(clone)) {
            if(count > 0){
                params += '&'+type+'='+val;
            }else{
                params += '?'+type+'='+val;
            }
            count++;
        }
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/wallets_transactions/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'));
        xmlHttp.setRequestHeader('Content-Language',language);
        xmlHttp.setRequestHeader('Accept-Language',language);
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {


            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, t("orders") +" "+get_date()+".xlsx");

        };

        xmlHttp.send(null);


    };


    const get_date = (date = null) => {
        let today = new Date();
        if(date !== null){
            today= new Date(date);
        }
        let day = today.getDate(); // Tag

        // Monatsangabe startet bei 0!
        let month = today.getMonth()+1; // Monat

        let year = today.getFullYear(); // Jahr
        if(day < 10) {
            day = '0'+ day;
        }
        if(month < 10) {
            month = '0'+ month;
        }
        today = day + '.' + month + '.' + year;

        return today;
    };

    const getMenu = () =>
    {
        let menu = [
            {
                text: t('export_xls', null, 'capital'),
                href: "#",
                iconClass: "ico-inb inb-fi-excel",
                rel: "noopener noreferrer",
                title: "export-xls",
                id: "export-xls",
                handler: _export
            }
        ];
        return menu;
    }

    return (
        <aside
            id="inb-c-sidebar"
            className="filemanager-sidebar"
            style={{float:'left'}}>
            <header className="inb-c-left-bar__title">
                <h1 className="inb-page-title">
                {props.heading}
                </h1>
                <SidebarMenu
                    menu={
                        getMenu()
                    }
                />
            </header>
            <aside id="inb-selected-filters">
                {filterCount > 0 && <ul>
                    <p>
                        <i className="fi fi-filter"> </i>
                        <span id="inb-selected-filters__count">
                               {" " + filterCount}
                             </span>

                        {" " + t('filter_selected')}
                        <a href="#"
                           id="inb-selected-filters__unset"
                           className="unset-filter"
                           title={t('unselect_all_filter')} onClick={(e) => {
                            resetFilter(e)
                        }}>
                            x
                        </a>
                    </p>
                </ul>}
            </aside>
            {!ready &&
            <Loader
                mediumWidth={4}
                smallWidth={4}
                subLoaders={2}/>
            }
            {ready &&
              <>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-locations"
                    heading={t('locations')}
                    type="select2"
                    data={locations}
                    dataKey="id"
                    ownStyle={{width:'25rem',position:'fixed'}}
                    onQueryHandle={onLocationQueryHandle}
                    onChangeHandle={onLocationSelectHandle}
                    selected={locationFilter === 'all'?locationFilter:null}
                    placeholder={'- ' + t('all',null,'capital') + ' -'}/> 
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-payment-method"
                    heading={t('payment_type')}
                    type="select"
                    data={[{
                        name:'- ' + t('all',null,'capital') + ' -', value:''},{
                        name:t('Online payment',null, 'capital')+' '+t('credit',null,'capital'),value:'Credit'},{
                        name:t('Online payment',null, 'capital')+' '+t('PayPal',null,'capital'),value:'PayPal'},{
                        name:t('Online payment',null, 'capital')+' '+t('sepa',null,'capital'),value:'sepa_debit'},{
                        name:t('Online payment',null, 'capital')+' '+t('googlePay',null,'capital'),value:'googlePay'},{
                        name:t('Online payment',null, 'capital')+' '+t('applePay',null,'capital'),value:'applePay'},{
                        name:t('Offline payment',null, 'capital')+' '+t('cash',null,'capital'), value:'cash'},{
                        name:t('Offline payment',null, 'capital')+' '+t('bank_transfer'),value:'Überweisung'},{
                        name:t('Offline payment',null, 'capital')+' '+'EC/Maestro',value:'EC/Maestro'},{
                        name:t('Offline payment',null, 'capital')+' '+'Visa',value:'Visa'},{
                        name:t('Offline payment',null, 'capital')+' '+'Mastercard',value:'Mastercard'}
                          ]}
                    dataKey="value"
                    selected={paymentMethodFilter !== null?paymentMethodFilter:null}
                    onChangeHandle={onPaymentTypeSelectHandle}/>
                  <SidebarFilter
                      id="inb-c-left-bar-flist--transactions-paystate"
                      heading={t('paystate')}
                      type="select"
                      data={[{
                          name:'- ' + t('all',null,'capital') + ' -', value:''},{
                          name:t('unpaid',null,'capital'), value:'unpaid'},{
                          name:t('paid',null,'capital'),value:'paid'},{
                          name:t('refunded',null,'capital'),value:'refund'}]}
                      dataKey="value"
                      selected={paystateFilter !== null?paystateFilter:null}
                      onChangeHandle={onPaystateSelectHandle}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-date"
                    heading={t('payment date',null, 'capital')}  //t('timespan',null,'capital')
                    type="datePicker"
                    data={[{
                        name: "date_from",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateFrom,
                        onChangeHandle: selectedDateFromHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: t('valid_from',null,'capital') + ' ...'
                    },{
                        name: "date_to",
                        className: "noBorders-noBackground",
                        dateFormat: "dd.MM.y",
                        selected: selectedDateTo,
                        onChangeHandle: selectedDateToHandle,
                        onKeyDownHandle: dateKeyDownHandle,
                        placeholder: ' ...' + t('valid_to',null,'capital'),
                    }]}/>
                <SidebarFilter
                        id="inb-c-left-bar-flist--transactions-payment-method2"
                        heading=""
                        type="list"
                        data={[{name:t('previous_year'),value:'previous_year'},
                               {name:t('today'),value:'current_day'},
                               {name:t('previous_day'),value:'previous_day'}]}
                        dataKey="value"
                        selected={selectedQuickfilter !== null ? selectedQuickfilter : 'nothingAtAllCauses'}
                        onChangeHandle={onQuickFilterSelectHandle}/>
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-month"
                    heading=""
                    type="select"
                    data={monthList}
                    dataKey="value"
                    selected={selectedMonthfilter}
                    onChangeHandle={onMonthSelectHandle}/>
                {false &&
                <SidebarFilter
                    id="inb-c-left-bar-flist--transactions-users"
                    heading={t('users')}
                    type="select2"
                    data={users}
                    dataKey="id"
                    nameAttribute="_name"
                    onQueryHandle={onUserQueryHandle}
                    onChangeHandle={onUserSelectHandle}
                    placeholder={'- ' + t('all',null,'capital') + ' -'}/>
                }
              </>
            }
            <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
                <a href="#"
                    id="toggle-left-bar"
                    className="button secondary show-for-small-only" onClick={(e) => onToggleLeftBar(e)}>
                        <i className="fi fi-filter"></i>
                        <span className="show-for-sr">t('open_filter_menu')</span>
                </a>
            </footer>
        </aside>
    );
};

export default TransactionsSidebar;

